import { z } from "zod/v4";

class ApiResponseError extends Error {
  errorBody: ErrorBody;
  constructor(body: ErrorBody) {
    super(body.message);
    this.name = body.name;
    this.errorBody = body;
  }
}
const ErrorBodySchema = z.object({
  name: z.string(),
  message: z.string(),
});

export function isApiResponseError(err: unknown): err is ApiResponseError {
  return typeof err === "object" && err instanceof ApiResponseError;
}
export type ErrorBody = z.infer<typeof ErrorBodySchema>;

export const GenericErrorResponseSchema = z
  .object({
    error: ErrorBodySchema,
  })
  .catch({
    error: {
      name: "UnknownError",
      message: "An unknown error occurred",
    },
  })
  .transform((response) => new ApiResponseError(response.error));
